import React from 'react';
import { SectionHeading } from './SectionHeading';
import { objectionSteps, objections } from '../data/content';
export function ObjectionSection() {
  return <section className="border-y-4 border-cream-deep bg-white px-4 py-6 sm:px-6" data-id="element-138" data-mp="1w13q47soloz5">
      <SectionHeading size="lg" data-id="element-139" data-mp="29zv2nprwb2l6">
        You don’t need more ideas scattered across the internet
      </SectionHeading>

      <p className="mt-3 text-center text-[13px] font-semibold text-graphite sm:text-sm" data-id="element-140" data-mp="25zb3yhrobqwx">
        You may be thinking:
      </p>

      <ul className="mx-auto mt-2 grid max-w-2xl gap-1 sm:grid-cols-2" data-id="element-141" data-mp="2ey4y81hj857b">
        {objections.map(objection => <li key={objection} className="rounded bg-cream px-3 py-1.5 text-[12px] font-semibold italic leading-snug text-graphite sm:text-[13px]" data-id="element-142" data-mp="2tlhmvz2myr1x">
            {objection}
          </li>)}
      </ul>

      <p className="mt-3 text-center font-heading text-lg font-extrabold uppercase text-terracotta" data-id="element-143" data-mp="32l4q8qexe6xm">
        Exactly.
      </p>

      <p className="mx-auto mt-1.5 max-w-2xl text-center text-[13px] font-medium leading-snug text-graphite sm:text-sm" data-id="element-144" data-mp="1gxfa4skwxsc">
        <strong className="font-extrabold text-navy" data-id="element-145" data-mp="6gtjo556ur8f">
          SENIOR ACTIVITY READY™
        </strong>{' '}
        isn’t designed to teach you how to work with older adults. It’s designed
        to make the activity side of your work easier to organize.
      </p>

      <ol className="mx-auto mt-3 grid max-w-2xl gap-1 sm:grid-cols-3" data-id="element-146" data-mp="kfjjvtnb1710">
        {objectionSteps.map((step, index) => <li key={step} className="flex items-center gap-2 rounded border border-navy/15 bg-cream px-2.5 py-1.5" data-id="element-147" data-mp="pduqzwm7t3fj" data-mpi={index}>
            <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-navy text-[10px] font-extrabold text-white" data-id="element-148" data-mp="u7frpwf70bif">
              {index + 1}
            </span>
            <span className="text-[12px] font-semibold leading-snug text-graphite" data-id="element-149" data-mp="1453kwhx5hayh">
              {step}
            </span>
          </li>)}
      </ol>

      <p className="mt-3 text-center text-[13px] font-bold text-navy sm:text-sm" data-id="element-150" data-mp="3558gu41golxi">
        Then use the system again tomorrow.
      </p>
      <p className="mt-1 text-center text-[13px] font-extrabold uppercase leading-tight text-terracotta sm:text-sm" data-id="element-151" data-mp="3088eo47qg3bo">
        You bring the experience. We give you the ready-to-use structure.
      </p>
    </section>;
}